import React from "react";
import myPhoto from "../assets/images/my-photo.jpg";
import { Link, NavLink } from "react-router-dom";

const navItems = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/projects", label: "Projects" },
];

const SunIcon = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    className="h-5 w-5"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2.5v2.5" />
    <path d="M12 19v2.5" />
    <path d="M4.9 4.9l1.8 1.8" />
    <path d="M17.3 17.3l1.8 1.8" />
    <path d="M2.5 12H5" />
    <path d="M19 12h2.5" />
    <path d="M4.9 19.1l1.8-1.8" />
    <path d="M17.3 6.7l1.8-1.8" />
  </svg>
);

const MoonIcon = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    className="h-5 w-5"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" />
  </svg>
);

const Navbar = ({ theme, setTheme }) => {
  return (
    <header className="sticky top-0 z-20 -mx-4 px-4 pt-6 backdrop-blur-sm sm:-mx-8 sm:px-8 sm:pt-8">
      <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-4">
          <Link
            to="/"
            className="flex h-14 w-14 items-center justify-center rounded-full bg-white/90 p-1 shadow-lg shadow-stone-900/5 ring-1 ring-stone-900/5 dark:bg-stone-900/90 dark:ring-stone-700/60"
            aria-label="Go to homepage"
          >
            <img
              className="h-12 w-12 rounded-full object-cover"
              src={myPhoto}
              alt="Obinna Okwuolisa"
            />
          </Link>
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.22em] text-stone-500 dark:text-stone-400">
              Obinna Okwuolisa
            </p>
            <p className="mt-1 text-sm text-stone-600 dark:text-stone-300">
              Senior Software Engineer | AI & Cloud Systems
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-3">
          <nav className="w-fit rounded-full bg-white/90 p-1 shadow-lg shadow-stone-900/5 ring-1 ring-stone-900/5 dark:bg-stone-900/90 dark:ring-stone-700/60">
            <ul className="flex flex-wrap items-center gap-1 text-sm font-medium text-stone-700 dark:text-stone-200">
              {navItems.map((item) => (
                <li key={item.label}>
                  <NavLink
                    end={item.end}
                    to={item.to}
                    className={({ isActive }) =>
                      [
                        "block rounded-full px-4 py-2 transition",
                        isActive
                          ? "bg-stone-900 text-stone-50 dark:bg-stone-100 dark:text-stone-900"
                          : "hover:bg-stone-100 hover:text-stone-900 dark:hover:bg-stone-800 dark:hover:text-stone-50",
                      ].join(" ")
                    }
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>

          <button
            type="button"
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-stone-700 shadow-lg shadow-stone-900/5 ring-1 ring-stone-900/5 transition hover:text-stone-950 dark:bg-stone-900/90 dark:text-stone-200 dark:ring-stone-700/60 dark:hover:text-stone-50"
            aria-label={
              theme === "dark" ? "Switch to light mode" : "Switch to dark mode"
            }
            title={
              theme === "dark" ? "Switch to light mode" : "Switch to dark mode"
            }
          >
            {theme === "dark" ? <SunIcon /> : <MoonIcon />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
